import { PolicyChangeStatusEnum, PolicyChangeTypeEnum } from '@program-suite/data-common';
import { AuthStore } from '@program-suite/data-auth';
import { inject } from '@angular/core';

export enum PolicyModalTypeEnum {
  AdditionalInsured = 'AdditionalInsured',
  CoverageAdjustment = 'CoverageAdjustment',
  Choice = 'Choice',
}

export function getModalTypeFromChangeType(changeType: PolicyChangeTypeEnum): PolicyModalTypeEnum {
  switch (changeType) {
    case 'NoticeOfCancellation':
    case 'Cancellation':
    case 'Reinstatement':
    case 'Other':
      return PolicyModalTypeEnum.Choice;
    case 'CoverageAdjustment':
      return PolicyModalTypeEnum.CoverageAdjustment;
    default:
      return PolicyModalTypeEnum.AdditionalInsured;
  }
}

export type Mode = 'edit' | 'add' | 'view';